import type { EducationDetailDto } from "../../types/client-education-detail.types";
import { useTranslation } from "react-i18next";
import styles from "./sections.module.scss";

export function DescriptionSection(props: { education: EducationDetailDto }) {
  const { t } = useTranslation();
  const text = props.education.description || props.education.content;
  if (!text) return null;
  return (
    <section id="description" className={styles.section}>
      <div className={styles.header}><h2>{t("common.description")}</h2></div>
      <div className={styles.description}>{text}</div>
    </section>
  );
}
